import { configureStore, combineReducers } from "@reduxjs/toolkit";
import applicantReducer from "./reducers/applicantReducer";
import adminUserReducer from "./reducers/adminUserReducer";
import approvalReducer from "./reducers/approvalReducer";
import userSliceReducer from '../reduxSlice/userSlice'
import applicantSliceReducer from '../reduxSlice/applicantSlice'
import batchApprovalReducer from "../reduxSlice/batchApprovalSlice";
import pendingApprovalParamsSlice from "../reduxSlice/pendingApprovalParamsSlice";
import batchInviteReducer from "../reduxSlice/batchInviteSlice";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from 'redux-thunk';

const persistConfig = {
    key: 'root',
    storage,
  }

  const rootReducer = combineReducers({ 
        applicant:applicantReducer,
        adminUser:adminUserReducer,
        approval:approvalReducer,
        user: userSliceReducer,
        applicantId: applicantSliceReducer,
        batchApproval: batchApprovalReducer,
        batchInvite: batchInviteReducer,
        updatePendingApprovalParams: pendingApprovalParamsSlice,
  })

  const persistedReducer = persistReducer(persistConfig, rootReducer)



export const  store = configureStore({
    reducer: persistedReducer,
    middleware: [thunk]   
});

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;